<script lang="ts">
  export let imageUrl: string;
  export let imageAltText: string | null = null;
  export let text: string = "";

</script>

<div data-testid="round-image">
  <figure>
    <img
      src={imageUrl}
      alt={imageAltText || text}
      class="fizz-radius-round fizz-stack-8 fizz-margin-auto"
    />
    {#if text}
      <figcaption class="fizz-text-center fizz-text-medium">
        <p>{text}</p>
      </figcaption>
    {/if}
  </figure>
</div>
